import { createFileRoute } from "@tanstack/react-router";
import { RouteError } from "../../../shared/components/RouteError";
import { RoutePending } from "../../../shared/components/RoutePending";
import { listSearch } from "../../../shared/utils/pagination-search";

const searchSchema = listSearch;

/**
 * @purpose Maintain the customer's sites (hotels, workshops)
 * @primary Locations table
 * @persona paola-admin-belora
 */
export const Route = createFileRoute("/app/c/$customerSlug/locations/")({
  validateSearch: searchSchema,
  errorComponent: ({ error }) => <RouteError error={error} />,
  pendingComponent: RoutePending,
});
